import { AnalyticsStore, ContextStore, ExperimentStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import * as React from 'react';

import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { SearchResultsStore } from 'src/common/stores/search-results-store';
import { UIPageStore } from 'src/common/stores/ui-page-store';

import { Results } from './results';
import { SearchErrorMessageWrapper } from '../search-error-message';
import * as ViewportListener from 'components/common/lazy/viewport-listener.js';

interface SearchResultsWrapperProps {
  searchResults?: SearchResultsStore;
  context?: ContextStore;
  uiPage?: UIPageStore;
  analytics?: AnalyticsStore;
  multiItem?: MultiItemStore;
  experiment?: ExperimentStore;
}

export const SearchResultsWrapper: React.FC<SearchResultsWrapperProps> = inject(
  'searchResults',
  'context',
  'uiPage',
  'analytics',
  'multiItem',
  'experiment'
)(({ searchResults, context, uiPage, analytics, multiItem, experiment }) => {
  const RENDER_REMAINING_AFTER_INDEX = 10;
  const resultRefs = [];
  const { searchCriteria, legalDisclaimer } = searchResults;
  const similarDestinationProps = multiItem?.isPackageShoppingPath()
    ? null
    : { inputs: { collectionId: 'similar_destinations' }, pageContext: { propertySearch: searchCriteria, context } };
  const handleShowMore = () => {
    refreshAds();

    uiPage.showProgressIndicator();

    searchResults.showMoreHotels(analytics, context, multiItem, uiPage, experiment).then(previousMax => {
      // Move focus to the first newly revealed HSR cards, for better screen reader experience.
      resultRefs[previousMax]?.focus();
    });
  };

  const renderErrorMessage = () => <SearchErrorMessageWrapper />;

  const setResultRef = (ref, index) => {
    if (ref === null || resultRefs[index] === ref) {
      return;
    }

    resultRefs[index] = ref;

    if (index === RENDER_REMAINING_AFTER_INDEX) {
      ViewportListener.subscribe(
        'window',
        ref,
        {
          didEnter: () => searchResults.setHotelsMaxDisplayToTotalRenderCount(),
        },
        { extendBoundingBoxToBottomOfPage: true, triggerOnce: true }
      );
    }
  };

  return (
    <Results
      handleShowMore={handleShowMore}
      legalDisclaimer={legalDisclaimer}
      setResultRef={setResultRef}
      errorMessage={renderErrorMessage()}
      similarDestinationProps={similarDestinationProps}
    />
  );
});

const refreshAds = () => {
  if (document && CustomEvent && typeof document.dispatchEvent === 'function') {
    document.dispatchEvent(new CustomEvent('mesoTriggeredRefresh', { detail: { type: 'impressionRefresh' } }));
  }
};
